import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  DateField,
  BooleanField,
  FunctionField,
  BulkUpdateButton,
} from "react-admin";
import { CircleOutlined, ErrorOutline } from "@mui/icons-material";
import Typography from "@mui/material/Typography";

import GlobalPagination from "../common/GlobalPagination";
import invoiceExportFilters from "./invoiceExportFilters";

export const invoiceExportRowStyle = (record: any, index: number) => ({
  backgroundColor: record.failed ? "#faa" : record.error ? "#fee" : "white",
});

const InvoiceExportList = () => (
  <List
    sort={{ field: "createdAt", order: "DESC" }}
    filters={invoiceExportFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
  >
    <Datagrid
      rowClick="show"
      rowStyle={invoiceExportRowStyle}
      bulkActionButtons={<InvoiceExportBulkActionButtons />}
    >
      <ReferenceField
        source="customerId"
        reference="Customer"
        sortable={false}
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>

      <TextField source="invoiceNumber" />

      <ReferenceArrayField
        source="serviceBookingIds"
        reference="ServiceBooking"
        sortable={false}
      >
        <SingleFieldList linkType={false}>
          <ChipField source="serviceTemplate.name" />
        </SingleFieldList>
      </ReferenceArrayField>

      <BooleanField
        source="failed"
        FalseIcon={CircleOutlined}
        TrueIcon={ErrorOutline}
        textAlign="center"
      />
      <FunctionField
        source="error"
        render={(record: any) => (
          <Typography component="span" variant="body2">
            {truncate(record?.error)}
          </Typography>
        )}
      />

      <DateField source="createdAt" showTime />
    </Datagrid>
  </List>
);

const InvoiceExportBulkActionButtons = () => {
  return (
    <>
      <BulkUpdateButton
        label="Fehler zurücksetzen"
        data={{ resetError: true }}
        mutationMode="pessimistic"
      />
    </>
  );
};

function truncate(str: string, length = 50) {
  if (!str) return str;
  return str.length > length ? str.substring(0, length) + "..." : str;
}

export default InvoiceExportList;
